import { Injectable } from '@angular/core';
import { HttpService } from '../../../shared/services/http/http-client.service';
import { environment } from '../../../../environments/environment';

const API = environment.url_server;

@Injectable({
  providedIn: 'root'
})
export class PlataformaPagamentoService {

  constructor(private http: HttpService, private httpService: HttpService) { }

  generatebase64(data: any, successHandle: Function, errorHandle: Function) {

    return this.httpService.doGet('/enterprise/returnReuseTermsConditions', data, successHandle, errorHandle);

  }

  taxasTermos(data: any, successHandle: Function, errorHandle: Function) {

    return this.httpService.doGet('/reuse/enterprise-product', data, successHandle, errorHandle);

  }

  buscaTaxas(data: any, successHandle: Function, errorHandle: Function) {

    return this.httpService.doGet('/enterprise/returnReusedInterestRates', data, successHandle, errorHandle);

  }

  buscarTaxaAgiliza(data: any, successHandle: Function, errorHandle: Function) {

    return this.httpService.doGet('/enterprise/taxaAntecipacao', data, successHandle, errorHandle);

  }

  aceiteTermo(data: any, successHandle: Function, errorHandle: Function) {

    return this.httpService.doPut('/reuse/enterprise-product', data, successHandle, errorHandle);

  }

}

